import Toolbar from '@material-ui/core/Toolbar';
import { makeStyles } from '@material-ui/core/styles';
import SettingsIcon from '@material-ui/icons/Settings';
import WarningIcon from '@material-ui/icons/Warning';
import {
    CustomBreadcrumbs,
    CustomFilter,
    CustomList,
    CustomSelectInput,
} from 'candy-commons-components';
import React from 'react';
import { CreateButton, TextField, useTranslate } from 'react-admin';
import CustomDatagrid from '../../components/organisms/customDatagrid';
import config from '../../config';
import { useSelector } from 'react-redux';
import {
    getApplianceTypes,
    getBrands,
    getSeries,
    getSeriesVersion,
} from '../../selectors/cmsConfig';
const useStyles = makeStyles({
    deprecationBanner: {
        display: 'flex',
        alignItems: 'center',
        gap: '8px',
        backgroundColor: '#fff3cd',
        border: '1px solid #ffc107',
        borderRadius: '4px',
        padding: '10px 16px',
        margin: '8px 0 16px',
        color: '#856404',
        fontSize: '14px',
    },
    deprecationIcon: {
        color: '#ffc107',
        flexShrink: 0,
    },
    deprecationLink: {
        color: '#014599',
        fontWeight: 600,
        textDecoration: 'underline',
        cursor: 'pointer',
    },
});

const SupportGuideHelpFilter = (props) => {
    const applianceTypes = useSelector(getApplianceTypes);
    const brands = useSelector(getBrands);
    const series = useSelector(getSeries);
    const seriesVersion = useSelector(getSeriesVersion);
    return (
        <CustomFilter {...props}>
            <CustomSelectInput
                source="applianceType"
                label="Appliance Types"
                choices={[
                    { id: 'GENERIC', name: 'GENERIC' },
                    ...applianceTypes,
                ]}
                alwaysOn
                initialValue=""
                allowEmpty={false}
            />
            <CustomSelectInput
                label="Brand"
                source="brand"
                allowEmpty
                alwaysOn
                choices={brands}
            />
            <CustomSelectInput
                label="Series"
                source="series"
                choices={series}
                alwaysOn
            />
            <CustomSelectInput
                label="SeriesVersion"
                source="series"
                choices={seriesVersion}
                alwaysOn
            />
        </CustomFilter>
    );
};
const AssetListAction = ({
    basePath,
    displayedFilters,
    filters,
    filterValues,
    resource,
    showFilter,
    permissions,
}) => {
    const username = localStorage.getItem(
        `CognitoIdentityServiceProvider.${config.userPoolWebClientId}.LastAuthUser`
    );
    const token = localStorage.getItem(
        `CognitoIdentityServiceProvider.${config.userPoolWebClientId}.${username}.idToken`
    );
    return (
        <Toolbar>
            {filters &&
                React.cloneElement(filters, {
                    resource,
                    showFilter,
                    displayedFilters,
                    filterValues,
                    context: 'button',
                })}
            {permissions && permissions.asset && permissions.asset.create && (
                <CreateButton basePath={basePath} />
            )}
        </Toolbar>
    );
};
const SupportGuideHelpList = ({ permissions, ...props }) => {
    const classes = useStyles();
    const translation = useTranslate();
    const breadcrumbsData = [
        {
            text: translation('resources.support-guide-help.name'),
            url: '',
            icon: <SettingsIcon />,
        },
    ];
    return (
        <>
            <CustomBreadcrumbs data={breadcrumbsData} />
            <div className={classes.deprecationBanner}>
                <WarningIcon className={classes.deprecationIcon} />
                <span>
                    ⚠️ <strong>Sezione deprecata (legacy).</strong> Questa
                    sezione non è più mantenuta. Per gestire le schermate di
                    attivazione RC, utilizza la sezione{' '}
                    <a
                        href="#/rc-activation-screen"
                        className={classes.deprecationLink}
                    >
                        RC Activation Screen
                    </a>
                    .
                </span>
            </div>
            <CustomList
                {...props}
                perPage={25}
                exporter={false}
                filters={<SupportGuideHelpFilter />}
                actions={<AssetListAction permissions={permissions} />}
                bulkActionButtons={
                    permissions &&
                    permissions['support-guide-help'] &&
                    permissions['support-guide-help'].delete
                        ? undefined
                        : false
                }
            >
                <CustomDatagrid selectable rowClick="edit">
                    <TextField source="applianceType" />
                    <TextField source="brand" />
                    <TextField source="series" />
                    <TextField source="seriesVersion" />
                    <TextField source="supportGuideHelpType" />
                </CustomDatagrid>
            </CustomList>
        </>
    );
};
export default SupportGuideHelpList;
